import { showEvaluationFeedback } from "./evaluationFeedback";

/**
 * @param element
 */
export function evaluateMessage(element) {
    element.off('click.evaluateMessage').on('click.evaluateMessage', function (event) {
        event.preventDefault();

        let submitBtn = $(this);
        let type = submitBtn.find('.icon-evaluate').attr('data-type');
        let messageEl = submitBtn.closest('.g-chatform-message');
        let messageId = messageEl.attr('data-id');

        if (submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
            return;
        }

        submitBtn.addClass('is-loading');

        /**
         * Analytics
         */
        if (typeof growtypeAnalyticsCapture === 'function') {
            growtypeAnalyticsCapture('growtype_analytics_growtype_chat_action_clicked', {
                title: 'evaluate_message',
                type: type
            });
        }

        /**
         * Show feedback panel — user picks a chip + optional comment,
         * then clicks Submit or Regenerate.
         */
        showEvaluationFeedback(type, messageId, submitBtn[0], {

            onSubmit: function (feedbackText, details) {
                return new Promise((resolve, reject) => jQuery.ajax({
                    url: growtype_chat_ajax.url,
                    type: 'post',
                    data: {
                        action: growtype_chat_ajax.evaluate_message_action,
                        type: type,
                        message_id: messageId,
                        nonce: growtype_chat_ajax.nonce,
                        feedback_text: feedbackText,
                        feedback_topics: details.topics,
                        feedback_comment: details.comment,
                    },
                    success: function (response) {
                        submitBtn.removeClass('is-loading');
                        if (response?.success && response?.data?.submission_id) {
                            resolve();
                        } else {
                            reject(new Error(response?.data?.message || 'Feedback could not be saved. Please try again.'));
                        }
                    },
                    error: function (response) {
                        submitBtn.removeClass('is-loading');
                        reject(new Error(response?.responseJSON?.data?.message || 'Feedback could not be saved. Please try again.'));
                    }
                }));
            },

            onRegenerate: async function (feedbackText, details) {
                await this.onSubmit(feedbackText, details);
                submitBtn.removeClass('is-loading');
                messageEl.find('.g-chatform-message-regenerate').trigger('click');
            },

            onCancel: function () {
                submitBtn.removeClass('is-loading');
            }
        });
    });
}
